import { 
    FETCH_EMAIL_TEMPLATES_REQUEST, FETCHING_EMAIL_TEMPLATES_SUCCEDDED, FETCHING_EMAIL_TEMPLATES_FAILED,
    FETCH_EMAIL_TEMPLATE_REQUEST, FETCHING_EMAIL_TEMPLATE_SUCCEDDED, FETCHING_EMAIL_TEMPLATE_FAILED,
    INVALIDATE_EMAIL_TEMPLATES, FETCH_DEFAULT_EMAIL_TEMPLATE_REQUEST, FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED, FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED

  } from 'src/redux/actions/actionTypes';
import {FetchEmailTemplatesRequest, FetchEmailTemplatesResponse, FetchEmailTemplatesErrorResponse,
    FetchEmailTemplateRequest, FetchEmailTemplateResponse, FetchEmailTemplateErrorResponse,
    FetchDefaultEmailTemplateResponse, FetchDefaultEmailTemplateErrorResponse
  } from 'src/types/emailTemplates.js'

import { createAction } from "@reduxjs/toolkit";
import buildUrl from "build-url-ts";
import axios from "axios";

import { takeEvery, call, put } from "redux-saga/effects";


const apiUrl = `${process.env.REACT_APP_API_URL}`;
const EMAIL_TEMPLATES_BASE_URL = `${apiUrl}/api/2.0/email-templates`;

export const fetchEmailTemplates = createAction<FetchEmailTemplatesRequest>(FETCH_EMAIL_TEMPLATES_REQUEST);
const fetchingEmailTemplatesSuccedded = createAction<FetchEmailTemplatesResponse>(FETCHING_EMAIL_TEMPLATES_SUCCEDDED);
const fetchingEmailTemplatesFailed = createAction<FetchEmailTemplatesErrorResponse>(FETCHING_EMAIL_TEMPLATES_FAILED);

const fetchEmailTemplatesSaga = function* (action: ReturnType<typeof fetchEmailTemplates>,): any {
    const { query, page } = action.payload;

    const param = { query,page};
    const fetchEmailTemplatesSagaAPI = () => {
    return axios({
      method: "GET",
      url: EMAIL_TEMPLATES_BASE_URL,
      params: param
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEmailTemplatesSagaAPI);
    yield put(fetchingEmailTemplatesSuccedded(response));
  } catch (error) {
    yield put(fetchingEmailTemplatesFailed({error}));
  }
};

export const fetchEmailTemplate = createAction<FetchEmailTemplateRequest>(FETCH_EMAIL_TEMPLATE_REQUEST);
const fetchingEmailTemplateSuccedded = createAction<FetchEmailTemplateResponse>(FETCHING_EMAIL_TEMPLATE_SUCCEDDED);
const fetchingEmailTemplateFailed = createAction<FetchEmailTemplateErrorResponse>(FETCHING_EMAIL_TEMPLATE_FAILED);

const fetchEmailTemplateSaga = function* (action: ReturnType<typeof fetchEmailTemplate>,): any {
    const {id} = action.payload;

    let url = buildUrl(EMAIL_TEMPLATES_BASE_URL, {
      path: `${id}`
    });

    const fetchEmailTemplateSagaAPI = () => {
    return axios({
      method: "GET",
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEmailTemplateSagaAPI);
    yield put(fetchingEmailTemplateSuccedded({id, template: response}));
  } catch (error) {
    yield put(fetchingEmailTemplateFailed({id, error}));
  }
};

export const fetchDefaultEmailTemplate = createAction(FETCH_DEFAULT_EMAIL_TEMPLATE_REQUEST);
const fetchingDefaultEmailTemplateSuccedded = createAction<FetchDefaultEmailTemplateResponse>(FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED);
const fetchingDefaultEmailTemplateFailed = createAction<FetchDefaultEmailTemplateErrorResponse>(FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED);

const fetchDefaultEmailTemplateSaga = function* (action: ReturnType<typeof fetchDefaultEmailTemplate>,): any {
    let url = buildUrl(EMAIL_TEMPLATES_BASE_URL, {
      path: `default`
    });

    const fetchDefaultEmailTemplateAPI = () => {
    return axios({
      method: "GET",
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDefaultEmailTemplateAPI);
    yield put(fetchingDefaultEmailTemplateSuccedded(response));
  } catch (error) {
    yield put(fetchingDefaultEmailTemplateFailed({error}));
  }
};

export const invalidateEmailTemplates = createAction<void>(INVALIDATE_EMAIL_TEMPLATES);

export default function* emailTemplatesSaga() {
    yield takeEvery(FETCH_EMAIL_TEMPLATES_REQUEST, fetchEmailTemplatesSaga);
    yield takeEvery(FETCH_EMAIL_TEMPLATE_REQUEST, fetchEmailTemplateSaga);
    yield takeEvery(FETCH_DEFAULT_EMAIL_TEMPLATE_REQUEST, fetchDefaultEmailTemplateSaga);

}